/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmittingInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import IsSubmitting from './IsSubmitting/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SubmittingInfo({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot/Edit/Content/SubmittingInfo"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageValueData = fromData.useDataValue({ viewPath,
context: 'image',
})
fromData.useSetFlowToBasedOnDataIsSubmitting({ viewPath,
context: 'image',
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'IsSubmitting'}>
<IsSubmitting
  viewPath={`${viewPath}/IsSubmitting`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}